import { DebouncedSearchInput } from '@lidea/shared/ui/core';
import { memo } from 'react';

import listPageStyles from '../desktop-data-list-page/desktop-data-list-page.module.css';

export type DesktopListSearchProps = {
  onDebouncedChange: (value: string) => void;
  debounceMs?: number;
};

export const DesktopListSearch = memo(function DesktopListSearch(
  props: DesktopListSearchProps
) {
  return (
    <DebouncedSearchInput
      className={listPageStyles.listSearch}
      debounceMs={props.debounceMs}
      onDebouncedChange={props.onDebouncedChange}
    />
  );
});
